import { underscore } from '@ember/string';
import BaseFragmentSerializer from '@square/dashboard-data/serializers/fragment';
import { EventLocationType } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
export default BaseFragmentSerializer.extend({
  keyForRelationship(key) {
    const underscored = underscore(key);
    return `${underscored}_id`;
  },
  normalize(type, payload) {
    const newPayload = {
      ...payload
    };
    newPayload.id = payload.uid;
    return this._super(type, newPayload);
  },
  serialize(snapshot) {
    const json = this._super(snapshot);
    json.uid = snapshot.id;

    // @array() attributes bypass serializeAttribute's protoEnum handling,
    // so convert eventLocationTypes to proto enum values for RPC requests.
    if (this.catalog.serializeForRpc && json.event_location_types) {
      json.event_location_types = json.event_location_types.map(type => EventLocationType[type] ?? type);
    }
    return json;
  },
  serializeBelongsTo(snapshot, json, relationship) {
    const key = relationship.key;
    const belongsTo = snapshot.belongsTo(key);
    if (belongsTo) {
      const relationalId = belongsTo.record?.idOrTempId();
      json.address_id = relationalId;
    } else {
      this._super(snapshot, json, relationship);
    }
  }
});